import { useId, useState } from 'react';
import styled from 'styled-components';
import { ActionForm, type FormSpec } from '@features/ksp-actions/ActionForm';
import { Drawer, DrawerBody, DrawerCloseButton, DrawerHeader } from '@shared/ui/Drawer';
import { Notice, Stack } from '@widgets/ksp-workspace/parts';

export interface ActionModalProps {
  form: FormSpec | null;
  busy?: boolean;
  /** Ошибки страницы: в панели — только появившиеся после её открытия. */
  errors?: string[];
  onClose: () => void;
}

const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 16px;
`;
const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  line-height: 1.35;
`;

/**
 * Форма действия КСП — боковой панелью поверх страницы. Раньше форма вставала над
 * вкладками, и после действия внизу длинной страницы (перенос работы на графике) её не
 * было видно. Ошибка отправки — в самой панели: страница под ней недоступна.
 */
export function ActionModal({ form, busy = false, errors = [], onClose }: ActionModalProps) {
  const titleId = useId();
  const key = form ? (form.id ?? form.title) : null;
  const [base, setBase] = useState({ key, count: errors.length });
  if (base.key !== key) setBase({ key, count: errors.length });
  const fresh = form && base.key === key ? errors.slice(base.count).slice(-3) : [];
  const close = () => {
    if (!busy) onClose();
  };
  return (
    <Drawer open={!!form} onClose={close} labelledBy={titleId}>
      {form && (
        <>
          <DrawerHeader>
            <HeaderRow>
              <Title id={titleId}>{form.title}</Title>
              <DrawerCloseButton onClick={close} />
            </HeaderRow>
          </DrawerHeader>
          <DrawerBody>
            <Stack>
              {fresh.map((text, index) => (
                <Notice key={`${base.count + index}`} $error role="alert">
                  {text}
                </Notice>
              ))}
              <ActionForm key={key} spec={form} busy={busy} onClose={close} bare />
            </Stack>
          </DrawerBody>
        </>
      )}
    </Drawer>
  );
}
